export const LOGIN = "LOGIN";
export const SIGNUP = "SIGNUP";
export const YEAR_SELECTION = "YEAR_SELECTION";
export const GUEST_LOGIN = "GUEST_LOGIN";
export const PRE_ENROLL_INFO = "PRE_ENROLL_INFO";
export const SET_SPINNER = "SET_SPINNER";
export const PLAN_SELECTION_CONTINUE = "PLAN_SELECTION_CONTINUE";
export const GET_CLINICAL_NAME = "GET_CLINICAL_NAME";
export const SUBMIT_FORM = "SUBMIT_FORM";
export const DOWNLOAD_PDF = "DOWNLOAD_PDF";
export const SAVE_LOGOUT = "SAVE_LOGOUT";
export const FOR_GOT_PD = "FOR_GOT_PD";
export const RE_SET_PD = "RE_SET_PD";
export const REMOVEPLAN="REMOVEPLAN";
export const SAVE_LANGUAGE="SAVE_LANGUAGE";
export const PDF_UPLOAD="PDF_UPLOAD";
export const CAPTCHA='CAPTCHA';
